import React, {useState} from 'react';
import { CircularProgress, Avatar, Button, CssBaseline, TextField, Box, Typography, Container } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Buffer } from 'buffer';
import { Link, useNavigate } from 'react-router-dom';
import { Context } from '../App';


export default function Login() {
    const navigate = useNavigate()
    const { setConnected, setUserId } = React.useContext(Context)
    const [loading, setLoad] = useState(false)
    const [msg, setMsg] = useState()

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const mail = data.get('mail')
        const mdp = data.get('password')

        if (!!mail&&mdp.length>=6) {
            setLoad(true)
            fetch(process.env.REACT_APP_API_URL.concat('/login'), {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + Buffer.from(mail+':'+mdp, 'utf-8').toString('base64'),
                },
            }).then(async(response)=> { 
                const token = response.headers.get('x-auth-token')
                if (response.ok&&!!token) {
                    const data = await response.json()
                    sessionStorage.setItem('token', token)
                    sessionStorage.setItem('user', data._id)
                    setUserId(data._id)
                    setConnected(true)
                    navigate('/dashboard') 
                }else{
                    const errorData = await response.json();
                    setMsg(errorData.error || "Erreur! impossible de se connecter.\nVeuillez vérifier vos identifiants ou contacter votre administrateur.")
                    setLoad(false)
                }
            })
        } else setMsg(!mail ? 'Veuillez entrer votre adresse email.' : 'Mot de passe trop court.\n Le mot de passe doit contenir 6 caractères minimums.');
    };

  return (
    <Box display='flex' flex={1} flexDirection='column' justifyContent='center' alignItems='center'>
        <div style={{display:'flex', width:"60%", height:"100vh", justifyContent:"center", alignItems:"center", flexDirection:'column'}}>
            <Typography variant='h3' align='center' marginTop={-25}>EVS pub CMS</Typography>
            <Typography variant='h6' align='center' marginTop={1}>Application de gestion des pubs et publications de l'EVS</Typography>
        
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
                >
                    <Avatar sx={{ m: 1, bgcolor: '#255760' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Connexion
                    </Typography>
                    <Typography color={'carmine.main'} align='center' sx={{whiteSpace:'pre-wrap'}}>{msg}</Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1}}>
                        <TextField required autoFocus fullWidth label="Adresse email" name="mail" type="email" autoComplete="email" sx={{marginBottom:3}}/>
                        <TextField required fullWidth  name="password" label="Mot de passe" type="password" />
                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading} >
                            {loading&&<CircularProgress size={18} color='primary' style={{marginRight:7}}/>} Valider
                        </Button>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Link to="/forgot-password" style={{ color: '#255760' }}>
                                Mot de passe oublié ?
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </div>
    </Box>
  );
}